import React, { Component } from 'react';
import MainLayout from "../common/MainLayout";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as pageActions from "../../actions/pages";

class User extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageName: 'USER'
        }
    }
    componentDidMount() {

        let data = {"name" : this.state.pageName};
        this.props.setPage(data);
    }


    render() {
        return(
          <MainLayout pageName= {this.state.pageName} />
        )
    }

}
export default  withRouter(connect(null, {
    setPage : pageActions.setPage
})(User));



// WEBPACK FOOTER //
// ./src/components/user/User.js